module.exports = __webpack_public_path__ + "img/location-off-blue.ec954e57.svg";